import React from "react";
import classes from "./CustomInput.module.css";

const CustomInput = (props: any) => {
    return <input className={`${props.className ? props.className : ""} ${classes.customInput}`} {...props} />;
};

export default CustomInput;
